module.exports = __webpack_public_path__ + "static/media/loaderWhite.6c95f68d.png";